import React from 'react';
import RealEstateDistribution from './RealEstateDistribution';

// Simplified Distribution - Always renders the Real Estate Distribution page
const Distribution = () => {
  return <RealEstateDistribution />;
};

export default Distribution;
